<template>
    <div class="flex items-center justify-end h-full" @mousedown.stop @click.stop>
        <div v-if="isDeleteConfirmationVisible" class="flex items-center gap-1">
            <UButton
                data-cy="confirm-delete-button"
                color="error"
                size="xs"
                class="rounded-sm"
                label="Slett"
                @click="props.params.context?.deleteIncomingDocument(incomingDocument)"
            />
            <UButton
                icon="i-ph-x"
                variant="ghost"
                size="xs"
                class="rounded-sm"
                color="neutral"
                @click="hideConfirm"
            />
        </div>

        <div v-else>
            <UButton
                icon="i-ph-download-simple"
                variant="ghost"
                size="xs"
                color="neutral"
                title="Last ned"
                @click="storageDownloadFile(props.params.data.documentMeta)"
            />
            <UButton
                icon="i-ph-trash-fill"
                variant="ghost"
                size="xs"
                color="neutral"
                title="Slett"
                data-cy="delete-document-button"
                @click="showConfirm"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {storageDownloadFile} from '@/services/document.service'
import {IncomingDocument} from '@/types/IncomingDocument'

const props = defineProps({
    isDeleteConfirmationVisible: Boolean,
    onShowDeleteConfirmation: {type: Function, required: true},
    onHideDeleteConfirmation: {type: Function, required: true},
    params: {
        type: Object as () => {
            data: IncomingDocument,
            context: {
                showDeleteConfirmation: (uuid: string) => void,
                hideDeleteConfirmation: (uuid: string) => void,
                deleteConfirmationState: { value: Record<string, boolean> },
                deleteIncomingDocument: (incomingDocument: IncomingDocument) => void
            }
        },
        required: true
    }
})

const incomingDocument = props.params.data

const isDeleteConfirmationVisible = computed(() =>
    props.params.context.deleteConfirmationState.value[incomingDocument.documentMeta.uuid] || false
)

const showConfirm = () => {
    props.params.context.showDeleteConfirmation(incomingDocument.documentMeta.uuid)
}

const hideConfirm = () => {
    props.params.context.hideDeleteConfirmation(incomingDocument.documentMeta.uuid)
}

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";


</style>